// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"7cd9ed68","354":"ab432966","452":"77b5859e","453":"3ca0ea6d","524":"d99c80ed","676":"83a7418b","824":"48a49fad"}[chunkId] + ".chunk.js";
};